import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import History from './pages/History';
import About from './pages/About';
import SignInRegister from './pages/SignInRegister';
import Conferences from './pages/Conferences';
import Projects from './pages/Projects';
import Partners from './pages/Partners';
import Workspace from './pages/Workspace';
import Contact from './pages/Contact';
// StaffMail removed - now external link to webmail.easyhost.be
import Profile from './pages/Profile';
import AdminDashboard from './pages/AdminDashboard';
import News from './pages/News';
import EventCalendar from './pages/EventCalendar';
import CMS from './pages/CMS';
import './App.css';

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/history" element={<History />} />
            <Route path="/about" element={<About />} />
            <Route path="/auth" element={<SignInRegister />} />
            <Route path="/login" element={<Navigate to="/auth" replace />} />
            <Route path="/register" element={<Navigate to="/auth" replace />} />
            <Route path="/conferences" element={<Conferences />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/workspace" element={<Workspace />} />
            <Route path="/contact" element={<Contact />} />
            {/* Staff Mail route removed - external link to webmail.easyhost.be */}
            <Route path="/profile" element={<Profile />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/news" element={<News />} />
            <Route path="/events" element={<EventCalendar />} />
            <Route path="/cms" element={<CMS />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
